import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-anamnese-invalid',
  templateUrl: './anamnese-invalid.component.html',
  styleUrls: ['./anamnese-invalid.component.scss']
})
export class AnamneseInvalidComponent {
  faCircleExclamation = faCircleExclamation;

  constructor(private router: Router) {}

  goHome() {
    this.router.navigate(['/']);
  }
} 